import React from 'react';
import { useNotify } from 'react-admin';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Card } from '@/components/Order';
import { Load, Filter } from '@/components/Global';
import {
  getOrder,
  AccRequest,
  RejectOrder,
  SaveData,
  AccRequestExport,
  RejectOrderExport,
} from '@/actions';
import { ParseOrder } from '@/actions/ParseData';
import styles from './styles';
import LoadingV2 from '@/components/Loading';

const perPage = 8;

export default ({ history }) => {
  const cls = styles();
  const notify = useNotify();
  const [loading, setLoading] = React.useState(true);
  const [DATA, setData] = React.useState([]);
  const [filter, setFilter] = React.useState({
    open: false,
    DATA: [],
  });

  const [page, setPage] = React.useState(1);
  const disableLoad = () => {
    if (page * perPage < DATA.length) return false;
    else return true;
  };

  const RefreshPage = useSelector((state) => state.reducer.refreshPage || '');

  const RefreshData = React.useCallback(() => {
    setLoading(true);
    getOrder('active')
      .then((res) => {
        let DATA = ParseOrder(res);
        setData(DATA);
        setFilter({ open: false, DATA });
        setLoading(false);
      })
      .catch((err) => {
        notify(err, 'warning');
        setLoading(false);
      });
  }, [notify]);

  React.useEffect(() => {
    if (RefreshPage === 'order') {
      RefreshData();
      SaveData({ refreshPage: '' });
    }
  }, [RefreshPage, RefreshData]);

  React.useEffect(() => {
    RefreshData();
  }, [RefreshData]);

  const AcceptEmpty = (item, count) => {
    AccRequest({
      id: item.id,
      count,
      mode: item.mode,
    })
      .then((res) => {
        notify(res);
        history.push('/orders/inprogress');
      })
      .catch((err) => notify(err, 'warning'));
  };

  const AcceptExport = (item, count) => {
    AccRequestExport({
      id: item.id,
      count,
      mode: item.mode,
    })
      .then((res) => {
        notify(res);
        history.push('/orders/inprogress');
      })
      .catch((err) => notify(err, 'warning'));
  };

  const RejectEmpty = (id) => {
    RejectOrder(id)
      .then(({ data, msg }) => {
        let DATA = ParseOrder(data);
        setData(DATA);
        setFilter({ open: false, DATA });
        notify(msg);
      })
      .catch((err) => notify(err, 'warning'));
  };

  const RejectExport = (id) => {
    RejectOrderExport(id)
      .then(({ data, msg }) => {
        let DATA = ParseOrder(data);
        setData(DATA);
        setFilter({ open: false, DATA });
        notify(msg);
      })
      .catch((err) => notify(err, 'warning'));
  };

  const getData = React.useCallback(
    () => filter.DATA.slice(0, page * perPage),
    [filter.DATA, page]
  );

  return (
    <div className={cls.content}>
      <Filter
        title="Active Offers"
        filter={filter}
        setFilter={setFilter}
        DATA={DATA}
      />

      <div className={cls.list}>
        {loading ? (
          <div className="mt-16">
            <LoadingV2 />
          </div>
        ) : (
          <Grid container spacing={2}>
            {getData().map((i, idx) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl="auto" key={idx}>
                <Card
                  DATA={i}
                  Accept={i.mode === 'empty' ? AcceptEmpty : AcceptExport}
                  Reject={i.mode === 'empty' ? RejectEmpty : RejectExport}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </div>
      <Load onLoad={() => setPage(page + 1)} disable={disableLoad()} />
    </div>
  );
};
